var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BriqLayout',{attrs:{"boldLinks":_vm.boldLinks,"normalLinks":_vm.normalLinks}},[_c('router-view'),_c('BriqEnvironment'),_c('BriqIconDefs'),_c('NotificationContainer'),_c('RefreshApiTokenDialog')],1)}
var staticRenderFns = []

export { render, staticRenderFns }